package com.appsyde.shared.modules.auth.domain.usecase

import com.appsyde.shared.modules.auth.domain.model.DomainResult
import com.appsyde.shared.modules.auth.domain.repo.AuthRepository

/** V1 Landing: Créer un compte — retourne l'URL OAuth Gmail+identity. */
class GetSignupUrlUseCase(private val authRepository: AuthRepository) {
    suspend operator fun invoke(redirectUri: String): DomainResult<String> =
        authRepository.getSignupUrl(redirectUri)
}
